const OrganizationTypes = Object.freeze({
  Group: "Group",
  ParentCompany: "ParentCompany",
});

export { OrganizationTypes };
